import { AbstractNodeList } from './AbstractNodeList.js';

export class AbstractDiff extends AbstractNodeList {

    /* AST API */
}